import { useState } from "react";
import Description from "../Inputs/Description";
import { BudgetItem, BudgetType, ColorHexes, CurrentUser, FamilyBucketLabel, FamilyFeatureValue, FamilyHasAccess } from "../../types";
import { Grid } from "@mui/material";
import ModalFooterSaveCancel from "./ModalFooterSaveCancel";
import ModalHeader from "./ModalHeader";
import { Circle } from "@uiw/react-color";
import Toggle from "../Inputs/Toggle";
import { Features } from "../../constants";
import { useSelector } from "react-redux";
import Dropdown from "../Inputs/Dropdown";

const EditBudgetName = (props: any) => {
	let [budget, setBudget] = useState(props.Item as BudgetItem);
	let user: CurrentUser = useSelector((state: any) => state.userData.value);
	const hasIncomeFeature = FamilyHasAccess(user, Features.Income);

	return (<>
		<ModalHeader Title="Budget Settings" Close={props.Close} />
		<div className="modal-body mt-5">
			<Grid container>
				<Description Label="Title" Value={budget.description} OnChange={(val: any) => UpdateDescription(val.target.value)} Size={12} />
				<Grid item xs={12}>
					Color:
					<Circle color={budget.color} colors={ColorHexes} onChange={UpdateColor} />
				</Grid>
				<Toggle Size={12} Label="Require approval from unassigned users" OnChange={UpdateRequiresApproval} Checked={budget.requiresApproval} className="my-3" />
				<Toggle Size={12} Label={`Exclude items in this budget from ${FamilyFeatureValue(user, Features.TransactionTitle)} page`} OnChange={UpdateIsViewTransactions} Checked={!budget.isViewTransactions} className="my-3" />
				{hasIncomeFeature && (
					<Dropdown
						Size={12}
						Class="mb-0"
						Label="Budget Type"
						Options={[
							{ Id: BudgetType.Expense, Value: "Expense" },
							{ Id: BudgetType.Income, Value: "Income" },
							{ Id: BudgetType.Combined, Value: "Combined" },
						]}
						Index={0}
						Value={budget.budgetType ?? BudgetType.Expense}
						OnChange={UpdateBudgetType}
					/>
				)}
				{budget.subBudgets && budget.subBudgets.length > 0 && (
					<Grid item xs={12} className="mt-4">
						<b>{`${FamilyBucketLabel(user, "subBudget", "SubBudget")}`} Titles:</b>
						{budget.subBudgets.map((sub, idx) => (
							<Grid container spacing={1} alignItems="center" key={idx} className="mb-2">
								<Grid item xs={6}>
									<Description
										NoLabel
										Value={sub.description ?? ""}
										OnChange={(val: any) => UpdateSubBudgetDescription(idx, val.target.value)}
										Size={12}
									/>
								</Grid>
							</Grid>
						))}
					</Grid>
				)}
			</Grid>
		</div>
		<ModalFooterSaveCancel ShowSave={ShouldShowSave()} Save={() => props.OnSave(budget)} Close={props.Close} />
	</>);

	function ShouldShowSave() {
		if (!budget.description) return false;
		return true;
	}

	function UpdateDescription(newValue: string) {
		var item = ({ ...budget, description: newValue });
		setBudget(item);
	}

	function UpdateColor(newValue: any) {
		let item = ({ ...budget, color: newValue.hex });
		setBudget(item);
	}

	function UpdateRequiresApproval(event: any, newValue: boolean) {
		let item = ({ ...budget, requiresApproval: newValue });
		setBudget(item);
	}
	function UpdateIsViewTransactions(event: any, newValue: boolean) {
		let item = ({ ...budget, isViewTransactions: !newValue });
		setBudget(item);
	}
	function UpdateBudgetType(newValue: any) {
		const nextType = newValue as BudgetType;
		let variant = { ...budget.variant };
		if (nextType === BudgetType.Income) {
			if ((variant.incomeAmount ?? 0) === 0 && (variant.amount ?? 0) > 0) variant.incomeAmount = variant.amount;
			variant.amount = 0;
		} else if (nextType === BudgetType.Expense) {
			if ((variant.amount ?? 0) === 0 && (variant.incomeAmount ?? 0) > 0) variant.amount = variant.incomeAmount;
			variant.incomeAmount = 0;
		}
		setBudget({ ...budget, budgetType: nextType, variant });
	}
	function UpdateSubBudgetDescription(idx: number, newValue: string) {
		const subBudgets = budget.subBudgets!.map((sub, i) => {
			if (i !== idx) return sub;
			return {
				...sub,
				description: newValue
			};
		});
		setBudget({ ...budget, subBudgets });
	}
}

export default EditBudgetName;